import {
  Box,
  MenuItem,
  Select,
  Typography,
  InputAdornment,
  TextField,
  IconButton,
  Stack,
  CircularProgress,
  useMediaQuery,
  debounce,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { Search } from "@mui/icons-material";
import React, {
  startTransition,
  useCallback,
  useEffect,
  useState,
} from "react";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import Grid from "@mui/material/Grid";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import dayjs from "dayjs";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  getFolders,
  updateEmail,
  getIndividualFoldersEmails,
  moveToFolder,
} from "../../../../services/api/apiManager";
import CreateNewFolder from "../emailSidebar/CreateNewFolder";
import {
  setDispatchFoldersId,
  setEmailId,
  setFoldersName,
} from "../../../../services/store/slice/ChatSlice";
import {
  setEmailsLength,
  setHandleSentEmail,
} from "../../../../services/store/slice/EmailSlice";
import { setRenderEmailList } from "../../../../services/store/slice/EmailSlice";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EmailWindow from "../emailWindow/emailWindow";

const NewFolders = ({ folder }) => {
  const [apiEmailListData, setApiEmailListData] = useState([]);
  const [apiFolderData, setApiFolderData] = useState([]);
  const [dateFilter, setDateFilter] = useState(
    localStorage.getItem("selectedFilter") || "AllMails"
  );
  const [hasFiles, setHasFiles] = useState(false);
  const [moveFolderFilter, setMoveFolderFilter] = useState([]);
  const userId = localStorage.getItem("user_id");
  const [openModal, setOpenModal] = useState(false);
  const [folderId, setFolderId] = useState(null);
  const [selectedID, setSelectedID] = useState([]);
  const EmailId = useSelector((state) => state?.chat?.emailId);
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [isRead, setIsRead] = useState();
  const [inboxMenu, setInboxMenu] = useState("");
  const [storeFolderId, setStoreFolderId] = useState("");
  const [itemPerPage, setItemPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  //for mobile screen
  const [emailWindowVisibility, setEmailWindowVisibility] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null); // Store the selected email data
  const [longPressTimer, setLongPressTimer] = useState(null);
  const isMobile = useMediaQuery("(max-width: 767px)"); // Adjust the breakpoint if needed
  const isDateFormat = /^\d{4}-\d{2}-\d{2}$/.test(dateFilter);

  // Handler when an email is clicked
  // const handleEmailClick = (item) => () => {
  //   setSelectedEmail(item); // Set the selected email data
  //   setEmailWindowVisibility(true); // Show the email window
  // };
  const handleEmailClick = (item) => (e) => {
    e.stopPropagation(); // Prevent the event from bubbling up to the parent click event
    setSelectedEmail(item); // Set the selected email data
    setEmailWindowVisibility(true); // Show the email window
  };
  // Handler to go back to the inbox
  const handleBackToList = () => {
    setEmailWindowVisibility(false); // Hide the email window
    setSelectedEmail(null); // Reset the selected email
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const actionType = useSelector((state) => state?.chat?.renderFolder);
  const renderEmailList = useSelector((state) => state?.email?.renderEmailList);

  const dispatchFolderId = useSelector(
    (state) => state?.chat?.dispatchFolderId
  );

  useEffect(() => {
    if (renderEmailList) {
      getUserEmailList(
        userId,
        apiPage?.inPageNumber,
        apiPage?.inRows,
        dispatchFolderId
      );
      dispatch(setRenderEmailList(false));
    }
  }, [renderEmailList]);

  useEffect(() => {
    dispatch(setDispatchFoldersId(localStorage.getItem("selectedId")));
  }, []);

  // getFolders
  async function getUserFolders(id) {
    try {
      const response = await getFolders(id);
      if (response?.status === 200) {
        setApiFolderData(response?.data?.result);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getUserFolders(userId);
  }, [actionType]);

  // region getEmailList
  async function getUserEmailList(
    id,
    page,
    row,
    FolderId,
    text,
    date,
    hasAttachment
  ) {
    try {
      setLoading(true);
      const response = await getIndividualFoldersEmails(
        id,
        page,
        row,
        FolderId,
        text,
        hasFiles ? "" : date,
        hasAttachment
      );

      if (response?.data?.result?.length === 0) {
        dispatch(setEmailId(null));
      }
      dispatch(setEmailsLength(response?.data?.result?.length));
      if (response?.status === 200) {
        setApiEmailListData(response?.data?.result);
        setCount(response?.data?.count);
        // if (defaultEmailShow === true) {
        //   dispatch(setEmailId(filterTodayData[0]?.emailId));
        //   dispatch(setDefaultEmailShow(false));
        // }
        // handleChange();
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }

  // Debounced API call - only runs when typing stops for 300ms
  const debouncedFetch = useCallback(
    debounce((value) => {
      getUserEmailList(
        userId,
        apiPage?.inPageNumber,
        apiPage?.inRows,
        dispatchFolderId,
        value,
        dateFilter,
        hasFiles
      );
      setCurrentPage(0);
    }, 500),
    []
  );

  useEffect(() => {
    getUserEmailList(
      userId,
      apiPage?.inPageNumber,
      apiPage?.inRows,
      dispatchFolderId,
      "",
      dateFilter,
      hasFiles
    );
  }, [dateFilter, hasFiles]);
  useEffect(() => {
    getUserEmailList(
      userId,
      apiPage?.inPageNumber,
      apiPage?.inRows,
      dispatchFolderId,
      "",
      "",
      false
    );
    setDateFilter(localStorage.getItem("selectedFilter") || "AllMails");
  }, [dispatchFolderId]);

  // region ReadEmail unread
  async function ReadUserEmail(data) {
    try {
      const response = await updateEmail(data);
      if (response?.status === 200) {
        getUserEmailList(
          userId,
          apiPage?.inPageNumber,
          apiPage?.inRows,
          dispatchFolderId,
          "",
          "",
          false
        );
        dispatch(setRenderEmailList(true));
        setSelectedID([]);
      }
    } catch (error) {
      console.error(error);
      setSelectedID([]);
    }
  }

  // region Move Emails from custom folder and move to Inbox
  const moveFromCustomFolder = async () => {
    try {
      const delTrashResp = await moveToFolder({
        emailId: [selectedID],
        folderId: dispatchFolderId,
        userId: userId,
        deleted: true,
      });

      if (delTrashResp.status === 200) {
        enqueueSnackbar("Email Moved successfully", { variant: "success" });
        dispatch(setRenderEmailList(true));
        getUserEmailList(
          userId,
          apiPage?.inPageNumber,
          apiPage?.inRows,
          dispatchFolderId,
          "",
          "",
          false
        );
      } else {
        enqueueSnackbar("Please Select Email", { variant: "error" });
      }
    } catch (error) {
      console.error("DelTrashMailsError", error);
    }
  };

  // region deleteEmail
  async function deleteUserEmail(data) {
    try {
      const response = await updateEmail(data);
      if (response?.status === 200) {
        dispatch(setRenderEmailList(true));
        getUserEmailList(
          userId,
          apiPage?.inPageNumber,
          apiPage?.inRows,
          dispatchFolderId,
          "",
          "",
          false
        );
        if (data?.IsTrash === true && selectedID.length != 0) {
          enqueueSnackbar("Deleted Successfully", { variant: "success" });
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  //new menu
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
  const [hoveredView, setHoveredView] = useState(false);
  const [isFolderMenuOpen, setIsFolderMenuOpen] = useState(false);
  const handleRightClick = (event) => {
    event.preventDefault();
    const { clientX: mouseX, clientY: mouseY } = event;
    setMenuPosition({ x: mouseX, y: mouseY });
    setIsContextMenuOpen(true);
  };
  const handleTouchStart = (event, emailId) => {
    const touchTarget = event.currentTarget;

    setLongPressTimer(
      setTimeout(() => {
        const rect = touchTarget.getBoundingClientRect();

        // Calculate available space
        const screenWidth = window.innerWidth;
        const menuWidth = 200; // Approximate width of your context menu (adjust as needed)

        let menuX = rect.right;
        let menuY = rect.bottom;

        // Adjust position if the menu overflows the screen
        if (menuX + menuWidth > screenWidth) {
          menuX = screenWidth - menuWidth - 10; // Add a 10px margin
        }

        setMenuPosition({ x: menuX, y: menuY }); // Set menu position
        setIsContextMenuOpen(true); // Open the context menu
        setSelectedID(emailId); // Set the selected email ID
      }, 500) // Long-press duration
    );
  };

  const handleTouchEnd = () => {
    clearTimeout(longPressTimer); // Clear the long-press timer
  };
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (isContextMenuOpen && !event.target.closest(".context-menu")) {
        handleCloseContextMenu();
      }
    };

    document.addEventListener("touchstart", handleOutsideClick);
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("touchstart", handleOutsideClick);
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isContextMenuOpen]);
  const handleCloseContextMenu = () => {
    setIsContextMenuOpen(false);
  };

  const handleViewMouseEnter = () => {
    setHoveredView(true);
  };

  const handleViewMouseLeave = () => {
    setHoveredView(false);
  };
  // menu

  // paginations
  const [apiPage, setApiPage] = useState({
    inPageNumber: 1,
    inRows: 100,
  });

  // functions

  const handleIconClick = () => {
    setOpen(true);
  };

  // Update the selected filter on change
  const handleChange = (event) => {
    setCurrentPage(0);
    setHasFiles(false);
    const selectedValue = event.target.value;
    setDateFilter(selectedValue);
    if (selectedValue == "HasAttachment") {
      setHasFiles(true);
    }
    localStorage.setItem("selectedFilter", selectedValue);
  };

  // region Update emails fav
  const FavEmails = async (data) => {
    try {
      const response = await updateEmail(data);
      if (response?.status === 200) {
        dispatch(setRenderEmailList(true));
        getUserEmailList(
          userId,
          apiPage?.inPageNumber,
          apiPage?.inRows,
          dispatchFolderId,
          "",
          "",
          false
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setInboxMenu(storeFolderId);
  }, [storeFolderId]);
  useEffect(() => {
    setStoreFolderId(dispatchFolderId);
  }, [dispatchFolderId]);

  // Define inboxMenuChange to update inboxMenu and handle navigation
  const inboxMenuChange = (event) => {
    const selectedValue = event.target.value;
    setInboxMenu(selectedValue);

    // Handle navigation based on selected value
    startTransition(() => {
      switch (selectedValue) {
        case "inbox":
          navigate("/emails/inbox");
          break;
        case "sent":
          navigate("/emails/sent");
          break;
        case "draft":
          navigate("/emails/draft");
          break;
        case "favourite": // Updated value for Favourite to make it unique
          navigate("/emails/favourite");
          break;
        case "trash": // Updated value for Trash to make it unique
          navigate("/emails/trash");
          break;
        default:
          // Navigate to custom folder if selected
          const selectedFolder = apiFolderData.find(
            (item) => item.folderName === selectedValue
          );
          if (selectedFolder) {
            navigate(`/emails/folder/${selectedFolder.folderId}`, {
              state: {
                folderId: selectedFolder.folderId,
                folderName: selectedFolder.folderName,
              },
            });
            localStorage.setItem("selectedCategory", selectedFolder.folderName);
            localStorage.setItem("selectedId", selectedFolder.folderId);
            dispatch(setDispatchFoldersId(selectedFolder.folderId));
            dispatch(setFoldersName(selectedFolder.folderName));
          }
      }
    });
  };

  // region Pagination
  const startIndex = currentPage * itemPerPage;
  const endIndex = Math.min(startIndex + itemPerPage, count);
  const paginationData = apiEmailListData?.slice(startIndex, endIndex);

  // Next page handler
  const handleNext = () => {
    if (endIndex < count) {
      setCurrentPage(currentPage + 1);
    }
    handlePaginationChange();
  };

  // Previous page handler
  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
    handlePaginationChange();
  };

  // region select pageSize menu

  const handlePagination = (event) => {
    setItemPerPage(event.target.value);
    setApiPage(() => {
      return {
        inPageNumber: 1,
        inRows: 100,
      };
    });
    setCurrentPage(0);
  };

  // region hit api in pagination function

  const handlePaginationChange = () => {
    if (currentPage != 0 && itemPerPage === 10 && currentPage % 9 === 0) {
      setApiPage((prev) => {
        return {
          inPageNumber: prev.inPageNumber,
          inRows: prev.inRows + 100,
        };
      });
    } else if (currentPage !== 0 && itemPerPage === 100) {
      setApiPage((prev) => {
        return {
          inPageNumber: prev.inPageNumber,
          inRows: prev.inRows + 100,
        };
      });
    } else if (currentPage === 0 && itemPerPage === 100) {
      setApiPage((prev) => {
        return {
          inPageNumber: prev.inPageNumber,
          inRows: prev.inRows + 100,
        };
      });
    } else if (
      currentPage != 0 &&
      itemPerPage === 25 &&
      currentPage % 3 === 0
    ) {
      setApiPage((prev) => {
        return {
          inPageNumber: prev.inPageNumber,
          inRows: prev.inRows + 100,
        };
      });
    } else if (
      currentPage != 0 &&
      itemPerPage === 50 &&
      currentPage % 1 === 0
    ) {
      setApiPage((prev) => {
        return {
          inPageNumber: prev.inPageNumber,
          inRows: prev.inRows + 100,
        };
      });
    }
  };

  useEffect(() => {
    if (apiFolderData && dispatchFolderId) {
      const result = apiFolderData.filter((item) => {
        return item?.folderId != dispatchFolderId;
      });
      setMoveFolderFilter(result);
    }
  }, [apiFolderData, dispatchFolderId]);

  return (
    <div>
      <Grid container spacing={1}>
        {/* left Email data */}
        {(!isMobile || !emailWindowVisibility) && (
          <Grid item xs={11.9} sm={11.9} md={3.4} lg={3.4} xl={3.4}>
            <Box
              sx={{
                // background: "white",
                bgcolor: "background.default",
                borderRadius: "6px",
                border: "1px solid lightgray",
                height: {
                  xs: "calc(100vh - 64px)",
                  xl: "97vh",
                  lg: "97vh",
                  md: "97vh",
                },
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                color: "text.primary",
                // height: "100%",
              }}
            >
              <Box>
                {/* Box1 filter */}
                <Box
                  sx={{
                    bgcolor: "background.default",
                    // background: "background.default",
                    display: "flex",
                    justifyContent: "space-between",
                    p: "5px 5px 0 5px",
                    height: "62px",
                  }}
                >
                  <Stack
                    sx={{
                      position: "relative",
                      padding: "0px",
                      margin: "0px",
                      bgcolor: "background.default",
                    }}
                  >
                    <FormControl
                      sx={{
                        top: 0,
                        zIndex: 1,
                      }}
                    >
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={isDateFormat ? "By Calendar" : dateFilter} // Set the value to selectedFilter
                        label="Filter"
                        onChange={handleChange}
                        sx={{
                          bgcolor: "background.default",
                          "& .MuiSelect-select": {
                            paddingRight: "30px", // Reduce space between value and arrow
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none", // Remove outline border
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: "none", // Remove outline on hover
                          },
                          "& .MuiSelect-icon": {
                            right: "10px", // Adjust the position of the dropdown icon if needed
                          },
                        }}
                      >
                        {isDateFormat && (
                          <MenuItem value="By Calendar">By Calendar</MenuItem>
                        )}
                        <MenuItem value="AllMails">All Mails</MenuItem>
                        <MenuItem value="Today">Today</MenuItem>
                        <MenuItem value="Yesterday">Yesterday</MenuItem>
                        <MenuItem value="This Month">This Month</MenuItem>
                        <MenuItem value="Previous Month">
                          Previous Month
                        </MenuItem>
                        <MenuItem value="HasAttachment">Has Files</MenuItem>
                      </Select>
                    </FormControl>
                  </Stack>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {open && (
                      <DatePicker
                        value={dayjs(dateFilter)}
                        onChange={(newDate) => {
                          const formattedDate =
                            newDate && newDate.isValid()
                              ? newDate.format("YYYY-MM-DD")
                              : null;
                          setDateFilter(formattedDate);
                          setHasFiles(false);
                        }}
                        open={open}
                        onClose={() => setOpen(false)}
                        renderInput={(params) => <TextField {...params} />}
                        sx={{
                          "& .MuiInputBase-root": {
                            visibility: "hidden",
                          },
                        }}
                      />
                    )}
                    <IconButton
                      onClick={handleIconClick}
                      sx={{ height: "40px", marginTop: "8px" }}
                    >
                      <CalendarMonthIcon />
                    </IconButton>
                  </LocalizationProvider>
                </Box>
                {/* Box2 search */}
                <Box
                  sx={{
                    display: "flex",
                    margin: "0 10px 10px 10px",
                    // backgroundColor: "background.default",
                    // bgcolor: "background.default",
                  }}
                >
                  <Box>
                    <TextField
                      variant="outlined"
                      placeholder="Search mail"
                      onChange={(e) => debouncedFetch(e.target.value)}
                      sx={{
                        backgroundColor: "search.main",
                        width: "100%",
                        borderRadius: "20px 0 0 20px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "20px 0 0 20px",
                        },
                        "& input::placeholder": {
                          fontSize: "12px",
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment>
                            <Search />
                          </InputAdornment>
                        ),
                        inputProps: {
                          style: {
                            height: "35px",
                            padding: "0 0px",
                            fontSize: "90%",
                          },
                        },
                      }}
                    />
                  </Box>
                  <FormControl sx={{ minWidth: "107px" }}>
                    <Select
                      value={inboxMenu}
                      onChange={inboxMenuChange}
                      displayEmpty
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                          },
                        },
                      }}
                      sx={{
                        height: "35px",
                        backgroundColor: "search.main",
                        borderRadius: "0 20px 20px 0",
                        fontSize: "80%",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "0 20px 20px 0",
                        },
                      }}
                    >
                      <MenuItem value="inbox">Inbox</MenuItem>
                      <MenuItem value="sent">Sent</MenuItem>
                      <MenuItem value="draft">Draft</MenuItem>
                      <MenuItem value="favourite">Favourite</MenuItem>
                      <MenuItem value="trash">Trash</MenuItem>

                      {apiFolderData?.map((item, index) => {
                        return (
                          <MenuItem
                            key={item?.folderId}
                            value={item?.folderId}
                            onClick={() => {
                              navigate(`/emails/folder/${item?.folderId}`);
                              localStorage.setItem(
                                "selectedId",
                                item?.folderId
                              );
                              dispatch(setDispatchFoldersId(item?.folderId));
                            }}
                          >
                            {item?.folderName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Box>

                {/* Right-click */}
                {isContextMenuOpen && (
                  <Box
                    className="context-menu"
                    style={{
                      left: `${menuPosition.x}px`,
                      top: `${menuPosition.y}px`,
                      position: "absolute",
                      // backgroundColor: "#ffffff",
                      backgroundColor: "background.default",
                      borderRadius: "4px",
                      boxShadow: `0 4px 6px rgba(0, 0, 0, 0.1)`,
                      zIndex: 1000,
                      width: `150px`,
                    }}
                    onMouseLeave={handleCloseContextMenu}
                  >
                    <Box
                      sx={{
                        padding: `8px 16px`,
                        fontSize: "13px",
                        cursor: `pointer`,
                        transition: `backgroundColor 0.2s`,
                        "&:hover": {
                          backgroundColor: "#f0f0f0",
                        },
                      }}
                      onClick={() => {
                        handleCloseContextMenu();
                        ReadUserEmail({
                          emailId: [selectedID],
                          IsRead: isRead ? false : true,
                          UserId: userId,
                          CreatedBy: parseInt(userId),
                        });
                      }}
                    >
                      {isRead ? "Mark as Unread" : "Mark as Read"}
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: "background.paper",
                        padding: `8px 16px`,
                        fontSize: "13px",
                        cursor: `pointer`,
                        transition: `backgroundColor 0.2s`,
                        "&:hover": {
                          backgroundColor: "hover",
                          // backgroundColor: "#f0f0f0",
                        },
                      }}
                      onClick={() => {
                        handleCloseContextMenu();
                        moveFromCustomFolder();
                      }}
                    >
                      Restore to Folder
                    </Box>
                    <Box
                      sx={{
                        padding: `8px 16px`,
                        cursor: `pointer`,
                        fontSize: "13px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        transition: `backgroundColor 0.2s`,
                        "&:hover": {
                          backgroundColor: ` #f0f0f0`,
                        },
                      }}
                      onMouseEnter={handleViewMouseEnter}
                      onMouseLeave={handleViewMouseLeave}
                    >
                      Move to Folder
                      <ArrowForwardIosIcon
                        sx={{
                          fontSize: "small",
                        }}
                      />
                      {hoveredView && (
                        <Box
                          sx={{
                            position: `absolute`,
                            left: `150px`,
                            top: 0,
                            backgroundColor: `#ffffff`,
                            boxShadow: `0 4px 6px rgba(0, 0, 0, 0.1)`,
                            borderRadius: `4px`,
                            marginTop: `20px`,
                            width: `150px`,
                            overflowY: "auto",
                            maxHeight: "170px",
                          }}
                        >
                          {moveFolderFilter?.map((item) => {
                            return (
                              <Box
                                sx={{
                                  padding: `8px 16px`,
                                  cursor: `pointer`,
                                  transition: ` backgroundColor 0.2s`,
                                  "&:hover": { backgroundColor: `#f0f0f0` },
                                }}
                                onClick={async () => {
                                  handleCloseContextMenu();
                                  try {
                                    const moveResponse = await moveToFolder({
                                      EmailId: [selectedID],
                                      FolderId: item?.folderId,
                                      UserId: userId,
                                    });
                                    if (moveResponse?.status === 200) {
                                      await getUserEmailList(
                                        userId,
                                        apiPage?.inPageNumber,
                                        apiPage?.inRows,
                                        dispatchFolderId,
                                        "",
                                        "",
                                        false
                                      );
                                      setSelectedID([]);
                                    } else {
                                      console.error("Failed to move email");
                                    }
                                  } catch (error) {
                                    console.error("Error moving email:", error);
                                  }
                                }}
                              >
                                {item.folderName}
                              </Box>
                            );
                          })}
                        </Box>
                      )}
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: "background.paper",
                        padding: `8px 16px`,
                        cursor: `pointer`,
                        color: "#265388",
                        fontSize: "13px",
                        transition: `backgroundColor 0.2s`,
                        "&:hover": {
                          // backgroundColor: "#f0f0f0",
                          backgroundColor: "hover",
                        },
                      }}
                      onClick={() => {
                        setOpenModal(true);
                        setFolderId(null);
                        handleCloseContextMenu();
                      }}
                    >
                      Create new Folder
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: "background.paper",
                        padding: `8px 16px`,
                        cursor: `pointer`,
                        fontSize: "13px",
                        color: "red",
                        transition: `backgroundColor 0.2s`,
                        "&:hover": {
                          // backgroundColor: "#f0f0f0",
                          backgroundColor: "hover",
                        },
                      }}
                      onClick={() => {
                        deleteUserEmail({
                          emailId: [selectedID],
                          UserId: userId,
                          IsTrash: true,
                          CreatedBy: parseInt(userId),
                        });
                        handleCloseContextMenu();
                      }}
                    >
                      Delete
                    </Box>
                  </Box>
                )}

                {/* Box3 table email data*/}
                {paginationData?.length <= 0 && loading === true ? (
                  <Box
                    minHeight={"150px"}
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <CircularProgress />
                  </Box>
                ) : paginationData?.length > 0 && loading === false ? (
                  <Box
                    sx={{
                      height: { xs: "calc(100vh - 225px)", md: "75vh" },
                      overflowY: "auto",
                      backgroundColor: "background.default",
                    }}
                  >
                    {paginationData &&
                      paginationData?.map((item, key) => {
                        const date = new Date(item?.createdDate);
                        const formattedDate = date.toLocaleDateString("en-GB");
                        // Format time as hh:mm AM/PM
                        const formattedTime = date.toLocaleTimeString("en-GB", {
                          hour: "2-digit",
                          minute: "2-digit",
                          // hour12: true, // 12-hour format with AM/PM
                        });

                        return (
                          <Box
                            key={key}
                            onContextMenu={(e) => {
                              handleRightClick(e);
                              setIsRead(item.isRead);
                            }}
                            onTouchStart={(e) => {
                              if (isMobile) {
                                handleTouchStart(e, item?.emailId); // For mobile long-press
                                setIsRead(item.isRead);
                              }
                            }}
                            onTouchEnd={() => {
                              if (isMobile) {
                                handleTouchEnd(); // Clear long-press timer
                              }
                            }}
                            onClick={handleEmailClick(item)}
                            // onClick={(e) => handleEmailClick(item, e)} // Pass event to handleEmailClick
                            xs={12}
                            sx={{
                              borderLeft: "4px solid #085f99",
                              marginBottom: "4px",
                              paddingLeft: "10px",
                              outline: "1px solid #00000026",
                              p: "2px",
                              backgroundColor: "background.default",
                              userSelect: "none", // Prevent text selection
                              WebkitUserSelect: "none",
                              // bgcolor:
                              //   EmailId == item?.emailId ? "#e5eaff" : "#fff",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                padding: "5px",
                              }}
                              onContextMenu={(e) => {
                                setSelectedID(item?.emailId);
                                //setFolderId(category?.folderId);
                                //setFolderNameSideBar(category?.folderName);
                              }}
                            >
                              <Box sx={{ width: "8%" }}>
                                {item?.isFav ? (
                                  <IconButton
                                    onClick={(event) => {
                                      event.preventDefault();
                                      event.stopPropagation();
                                      FavEmails({
                                        emailId: [item?.emailId],
                                        isFav:
                                          item?.isFav === true ? false : true,
                                        UserId: userId,
                                        Deleted: false,
                                        CreatedBy: parseInt(userId),
                                      });
                                    }}
                                    sx={{ width: "20px", height: "20px" }}
                                  >
                                    <StarIcon
                                      fontSize="small"
                                      style={{
                                        color: "#FFD700",
                                        fontSize: "20px",
                                        marginRight: "10px",
                                      }}
                                    />
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    onClick={() => {
                                      FavEmails({
                                        emailId: [item?.emailId],
                                        isFav:
                                          item?.isFav === true ? false : true,
                                        UserId: userId,
                                        Deleted: false,
                                        CreatedBy: parseInt(userId),
                                      });
                                    }}
                                    sx={{ width: "20px", height: "20px" }}
                                  >
                                    <StarBorderIcon
                                      fontSize="small"
                                      style={{
                                        fontSize: "20px",
                                        marginRight: "10px",
                                      }}
                                    />
                                  </IconButton>
                                )}
                              </Box>
                              <Box
                                onClick={() => {
                                  localStorage.setItem(
                                    "emailIds",
                                    item?.emailId
                                  );
                                  dispatch(setEmailId(item?.emailId));
                                  dispatch(setHandleSentEmail(false));
                                  if (
                                    item?.isRead === false ||
                                    item?.isRead === null
                                  ) {
                                    ReadUserEmail({
                                      emailId: [item?.emailId],
                                      IsRead: true,
                                      UserId: userId,
                                      CreatedBy: parseInt(userId),
                                    });
                                  }
                                }}
                                sx={{
                                  cursor: "pointer",
                                  width: "92%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Box>
                                  <Typography
                                    sx={{
                                      fontFamily: "Poppins",
                                      fontWeight: item?.isRead
                                        ? "normal"
                                        : "bold",
                                      color: item?.isRead
                                        ? "gray"
                                        : "text.primary",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {item?.senderFirstName?.length > 15 &&
                                    item?.senderLastName?.length > 10
                                      ? `${item?.senderFirstName?.slice(0, 15)} 
                                    ${item?.senderLastName?.slice(0, 10)}...`
                                      : `${item?.senderFirstName} ${item?.senderLastName}`}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: "Poppins",
                                      fontWeight: item?.isRead
                                        ? "normal"
                                        : "bold",
                                      color: item?.isRead
                                        ? "gray"
                                        : "text.primary",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {item?.subject?.length > 22
                                      ? item?.subject?.slice(0, 22) + "..."
                                      : item?.subject}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "12px",
                                    }}
                                  >
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          item?.body?.replace(/<[^>]*>/g, "")
                                            ?.length > 18
                                            ? item?.body
                                                ?.replace(/<[^>]*>/g, "")
                                                ?.slice(0, 18) + "..."
                                            : item?.body?.replace(
                                                /<[^>]*>/g,
                                                ""
                                              ),
                                      }}
                                      style={{
                                        fontWeight: item?.isRead
                                          ? "normal"
                                          : "bold",
                                        color: item?.isRead
                                          ? "gray"
                                          : "text.primary",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 4,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    />
                                  </Typography>
                                </Box>
                                <Box>
                                  <Typography
                                    sx={{
                                      fontSize: "11px",
                                      fontFamily: "Poppines",
                                    }}
                                  >
                                    {/* {formattedDate} {formattedTime} */}
                                    {dayjs(item?.createdDate)
                                      ?.add(13, "hour")
                                      ?.format("MM/DD/YYYY hh:mm A")}
                                  </Typography>
                                </Box>
                              </Box>
                              {/* favIcons */}
                            </Box>
                          </Box>
                        );
                      })}
                  </Box>
                ) : (
                  <Box
                    minHeight={"150px"}
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Typography>No Email</Typography>
                  </Box>
                )}
              </Box>

              <Stack
                direction={"row"}
                mb={"10px"}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "48px",

                  // position: { xs: "fixed", md: "relative" },
                  // bottom: 0,
                  // width: "100%",
                  // right: 0,
                  // left: 0,
                }}
              >
                <FormControl sx={{ m: 1, maxWidth: 80 }}>
                  <Select
                    value={itemPerPage}
                    onChange={handlePagination}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{ height: 30 }}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                <Typography fontSize={"small"}>
                  {count === 0 ? 0 : startIndex + 1} - {endIndex} of {count}
                </Typography>
                <Box spacing={2}>
                  <IconButton
                    onClick={handlePrevious}
                    disabled={startIndex <= 0}
                  >
                    <ArrowBackIosRoundedIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    onClick={handleNext}
                    disabled={endIndex === count}
                  >
                    <ArrowForwardIosRoundedIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Stack>
            </Box>
          </Grid>
        )}
        {/* right window data */}
        {(isMobile ? emailWindowVisibility : true) && (
          <Grid item xs={12} md={8.5}>
            <Box
              sx={{
                backgroundColor: "background.default",
                borderRadius: "6px",
                border: "1px solid lightgray",
                height: { xs: "calc(100vh - 64px)", md: "97vh" },
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Email Window Content */}
              {selectedEmail ? (
                <EmailWindow email={selectedEmail} onBack={handleBackToList} />
              ) : (
                <Typography sx={{ p: 2 }}>No email selected</Typography>
              )}
            </Box>
          </Grid>
        )}
      </Grid>
      {/* Modal */}
      <CreateNewFolder
        openModal={openModal}
        setOpenModal={setOpenModal}
        folderId={folderId}
      />
    </div>
  );
};

export default NewFolders;
